angular.module('core')
  .directive('infiniteScroller', ['$document', '$window', function ($document, $window) {
    var threshold = 100;

    return function(scope, element, attrs) {
        var notifyScrolledToBottom = function () {
            scope.$broadcast('scrolledToBottom');
        };

        if (element[0] && element[0].tagName && element[0].tagName.toLowerCase() === 'html') {
            angular.element($window).scroll(function (event) {
                var target = angular.element(event.currentTarget);
                var position = target.scrollTop() + target.height();
                var size = angular.element($document).height();

                if (position >= size - threshold) {
                    notifyScrolledToBottom();
                }
            });
        } else {
            element.scroll(function(event) {
                var target = event.currentTarget;
                var position = target.scrollTop + target.offsetHeight;
                var size = target.scrollHeight;

                // Prevent notification when no scrollbar.
                // Can happen when content size is reduced in
                // target as in switching between students when on
                // student activity tab.
                // IN-726
                if (position === size && target.scrollTop === 0) {
                    return;
                }

                if (position >= size - threshold) {
                    notifyScrolledToBottom();
                }
            });
        }
    };
  }]);
